import React from "react";
import searchIcon from "../../assets/svg/search.svg";
import dateIconNew from "../../assets/svg/date.svg"
import clearIcon from "../../assets/svg/buttoncancelrequestIcon.svg";
import Filter from "../../assets/svg/filter.svg"
import addIcon from "../../assets/svg/addicon.svg";
import upArrow from "../../assets/svg/uparrow.svg";
import downArrow from "../../assets/svg/downarrow.svg";
import WarningIcon from "../../assets/svg/warningicon.svg";
import CrossIcon from "../../assets/svg/crossicon.svg";
import ButtonSubmitIcon from "../../assets/svg/ButtonSubmitIcon.svg";
import ButtonRejectIcon from "../../assets/svg/buttoncancelrequestIcon.svg";
import blankFile from "../../assets/svg/closeToast.svg";
import departmentFile from '../../assets/svg/department.svg';

// My training
import TrainingIcon from "../../assets/svg/TrainingIcon.svg";
import employeecode from "../../assets/svg/employeecode.svg";
import coursetitle from "../../assets/svg/coursetitle.svg";
import coursecode from "../../assets/svg/coursecode.svg";
import requestedby from "../../assets/svg/requestedby.svg";
import skilleval from "../../assets/svg/skill_eval.svg";
import trainingbondicon from "../../assets/svg/TrainingBondIcon.svg";
import AttachIcon from "../../assets/svg/Attach_Icon.svg";
import Skill_Job_Icon from "../../assets/svg/SkillJobIcon.svg";
import SkillKnowledgeIcon from "../../assets/svg/SkillKnowledgeIcon.svg";

// Vendors
import Vendorslogo from "../../assets/svg/vendorlogo.svg";
import VendorCodeIcon from "../../assets/svg/employeecode.svg";
import VendorNameIcon from "../../assets/svg/vendorname.svg";
import ContactPersonIcon from "../../assets/svg/employeename.svg";
import ContactNumberIcon from "../../assets/svg/contactnumber.svg";
import AddressIcon from "../../assets/svg/address.svg";
import CommentIcon from "../../assets/svg/CommentIcon.svg";
import VendorSubmit from "../../assets/svg/vendorsubmit.svg";
import VendorEmail from "../../assets/svg/vendoremailIcon.svg";
import SupervisorIcon from "../../assets/svg/Supervisor.svg";
import statusIcon from "../../assets/svg/Status.svg";
//PTE
import PTEMaxIcon from "../../assets/svg/PTEActiveIcon.svg";
import pteIcon from "../../assets/svg/pteIcon.svg";
import jobIcon from "../../assets/svg/jobicon.svg";
import skillKonwIcon from "../../assets/svg/skillKonwIcon.svg";

// Course questionnaire
import vendoraddIcon from "../../assets/svg/vendoraddicon.svg";
import courseQuestionaireLogo from "../../assets/svg/coursequestionnairelogo.svg";
import CourseQuestionIcon from "../../assets/svg/courequestionnaireicon.svg";
import smallCrossIcon from "../../assets/svg/smallcrossicon2.svg";
// Course category
import Coursecatalogueiconactive from "../../assets/svg/coursecatalogueactive.svg";
import CourseCodeIcon from "../../assets/svg/coursecode.svg";
import CourseTitleIcon from "../../assets/svg/CourseTitleIcon.svg";
import courseQuestionaireIcon from "../../assets/svg/courequestionnaireicon.svg";
import courseCategoryIcon from "../../assets/svg/coursecategoryicon.svg";
import courseProviderIcon from "../../assets/svg/courseprovidericon.svg";
import courseDescIcon from "../../assets/svg/couredescicon.svg";
import skillIcon from "../../assets/svg/skillicon.svg";
import pteActive from "../../assets/svg/pteActive.svg";
import cqActiveIcon from "../../assets/svg/coureActiveIcon.svg";
import edit from "../../assets/svg/edit.svg";
import addCourse from "../../assets/svg/addcourse.svg";
import textCourse from "../../assets/svg/textCourse.svg";
import textCourseRed from "../../assets/svg/textCourseRed.svg";
import courseDuration from "../../assets/svg/courseDuration.svg";
import successTick from "../../assets/svg/successTick.svg";
import certificateCourseCatalogue from "../../assets/svg/certificateCourseCatalogue.svg";
import urlWhite from "../../assets/svg/urlWhite.svg";
import url from "../../assets/svg/url.svg";
import exportIcon from "../../assets/svg/exportIcon.svg";
import courseMasterActive from "../../assets/svg/courseMasterActive.svg";
import courseMaster from "../../assets/svg/courseMaster.svg";

//PendingApprovals
import LeftArrowIcon from "../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../assets/svg/RightArrow.svg";
import PendingApprovalIcon from "../../assets/svg/mypendingapprovalactiveicon.svg";
import RequestIcon from "../../assets/svg/RequestIcon.svg";
import EmployeeCodeIcon from "../../assets/svg/employeecodeicon.svg";
import RequestedByIcon from "../../assets/svg/requestedbyicon.svg";
import UserIcon from "../../assets/svg/UserIcon.svg";
import DateIcon from "../../assets/svg/DateIcon.svg";
import PropertiesIcon from "../../assets/svg/PropertiesIcon.svg";
import ButtonApproveIcon from "../../assets/svg/buttonapproveIcon.svg";
import VersionIcon from "../../assets/svg/versionlog.svg";
import AttchementIcon from "../../assets/svg/AttchementIcon.svg";
import NewAttachmentIcon from "../../assets/svg/attachements.svg";
import BackArrowIcon from "../../assets/svg/backarrowIcon.svg";
import NextArrowIcon from "../../assets/svg/nextarrowIcon.svg";
import AttachementCloseIcon from "../../assets/svg/AttchCloseIcon.svg";
import ButtonSubmitApprovalIcon from "../../assets/svg/ButtonSubmitIcon.svg";
import ButtonRejectApprovalIcon from "../../assets/svg/buttoncancelrequestIcon.svg";
import ButtonApprovalIcon from "../../assets/svg/buttonapproveIcon.svg";
import upload from "../../assets/svg/upload.svg";
import prevBackIcon from "../../assets/svg/prevBackIcon.svg";

// master data
import courseCategoryMaxIcon from "../../assets/svg/categorymaxIcon.svg";
import EditIcon from "../../assets/svg/editIcon.svg";
import RemoveIcon from "../../assets/svg/removeIcon.svg";
import SubCategoryIcon from "../../assets/svg/smallcrossicon.svg";
import skillMaxIcon from "../../assets/svg/skillMaxIcon.svg";
import jobMaxIcon from "../../assets/svg/jobMaxIcon.svg";
import jobicon from "../../assets/svg/jobicon.svg";
import jobactiveicon from "../../assets/svg/jobactiveicon.svg";
import skillJobIcon from "../../assets/svg/skills_jobs.svg";
import skillJobActiveIcon from "../../assets/svg/skill_jobactiveicon.svg";
import skillJobMaxIcon from "../../assets/svg/skill_jobMaxIcon.svg";
import supportingMaxIcon from "../../assets/svg/supportingMaxIcon.svg";
import supportingIcon from "../../assets/svg/supportingicon.svg";
import supportingActiveIcon from "../../assets/svg/supportingactiveicon.svg";

//My Pending Task
import Pendingheading from "../../assets/svg/pendingheading.svg";
import PendingTaskHome from "../../assets/svg/pendingTaskHome.svg";
import crossicon from "../../assets/svg/crossicon.svg";
import crossiconupload from "../../assets/svg/crossicon.svg";
import cancelrequest from "../../assets/svg/cancelrequest.svg";
import FailedIcon from "../../assets/svg/failedicon.svg";
import requesteddate from "../../assets/svg/reqdate.svg";
import submiticon from "../../assets/svg/submiticon.svg";
import employeename from "../../assets/svg/employeename.svg";
import historylog from "../../assets/svg/historylog.svg";
import preskillevaluation from "../../assets/svg/preskillevaluation.svg";
import certificatecoursetitle from "../../assets/svg/certificatecourse.svg";
import employeeid from "../../assets/svg/louemployeeIcon.svg";
import currentstatus from "../../assets/svg/currentstatusIcon.svg"
import requestId from "../../assets/svg/requestIdIcon.svg"
import searchIcon1 from "../../assets/svg/searchIcon.svg"
import calenderDate from "../../assets/svg/calenderDate.svg"
import searchableIcon from "../../assets/svg/searchableIcon.svg"
import clearIcon1 from "../../assets/svg/clearIcon.svg"
import filterIcon from "../../assets/svg/filter.svg"
import filterIconFill from "../../assets/svg/filterIconFill.svg"
import Filter1 from "../../assets/svg/filter copy.svg"
import backicon from "../../assets/svg/backicon.svg";

//My Pending Submission
import docAttach from "../../assets/svg/doc_attach.svg";

//Skill Matrix
import Skillmatrixicon from "../../assets/svg/skillmatrixactive.svg";
import staricon from "../../assets/svg/staricon.svg";

//skill overview
import skilloverviewactive from "../../assets/svg/skilloverviewactive.svg";

// upcoming Training
import upcomingTraining from "../../assets/svg/upcomingTraining.svg";
import hoursIcon from "../../assets/svg/hoursIcon.svg";
import costTrainingIcon from "../../assets/svg/costTrainingIcon.svg";
import backButtonIcon from "../../assets/svg/backButtonIcon.svg";
import downloadIcon from "../../assets/svg/downloadIcon.svg";
import Companyhead from "../../assets/svg/Company_head.svg";
import Companyside from "../../assets/svg/Company_side.svg";
import Company_side_inActive from "../../assets/svg/Company_side_inActive.svg";

//My team
import myteamactive from "../../assets/svg/myteamactive.svg";

//Home
import myjob from "../../assets/svg/myjob.svg";
import pendinghome from "../../assets/svg/pendinghome.svg";
import pendingTraining from "../../assets/svg/myTrainingActiveIcon.svg";
import homeTraining from "../../assets/svg/homeupcomingIcon.svg";
import directTraning from "../../assets/svg/directtraningIcon.svg";
import mytraininghome from "../../assets/svg/mytraininghome.svg";
import directreports from "../../assets/svg/directreports.svg";
import upcomingtraining from "../../assets/svg/upcomingTraining.svg";
import forwardicon from "../../assets/svg/forwardicon.svg";
import developmentplan from "../../assets/svg/developmentplan.svg";
import traininghours from "../../assets/svg/traininghours.svg";
import description from "../../assets/svg/description.svg";
import traningRecordsHome from "../../assets/svg/trainingrecordsIcon.svg"

// Level

import levelActive from "../../assets/svg/levelActive.svg";
import levelIcon from "../../assets/svg/levelIcon.svg";

// proficiency

import proficiencyIcon from "../../assets/svg/proficiencyIcon.svg";
import proficiencyActiveIcon from "../../assets/svg/proficiencyActive.svg";
import template from "../../assets/svg/template.svg";
import proficiencyExpected from "../../assets/svg/proficiencyexpected.svg";
import back from "../../assets/svg/backicon.svg";

// Lou

import louactiveicon from "../../assets/svg/louactiveicon.svg";
import louicon from "../../assets/svg/louicon.svg";

//Team training
import teamtrainingActive from "../../assets/svg/teamtrainingActive.svg";
import skillActiveIcon from "../../assets/svg/skillactiveicon.svg";

//Notification\
import notifyActive from "../../assets/svg/notifyActive.svg"

//My Request Status
import requestStatusIcon from "../../assets/svg/requestStatusIcon.svg"
import requestStatusActiveIcon from "../../assets/svg/requestStatusActiveIcon.svg"
import MyrequestStatusIcon from "../../assets/svg/MyrequestStatusIcon.svg"
import trainingRecords from "../../assets/svg/trainingRecords.svg"

import mySelfIcon from "../../assets/svg/mySelfIcon.svg";
import mySelfIconActive from "../../assets/svg/mySelfIconActive.svg";

const CommonIcon = ({ fileName }) => {
  if (fileName) {
    switch (fileName) {
      case "PropertiesIcon":
        return <img src={PropertiesIcon} alt="" className="properties-img-current" />;
      case "departmentIcon":
        return <img src={departmentFile} alt="" className="properties-img-3" />;
      case "template":
        return <img src={template} alt="" />;
      case "DateIcon":
        return <img src={DateIcon} alt="" className="properties-img" />;
      case "UserIcon":
        return <img src={UserIcon} alt="" className="properties-img" />;
      case "AttchementIcon":
        return (
          <img src={AttchementIcon} alt="" className="properties-search-img" />
        );
      case "VersionIcon":
        return <img src={VersionIcon} alt="" className="properties-img" />;
      case "ButtonApproveIcon":
        return <img src={ButtonApproveIcon} alt="" />;
      case "ButtonApprovalIcon":
        return <img src={ButtonApprovalIcon} alt="" className="button-img" />;
      case "LeftArrowIcon":
        return <img src={LeftArrowIcon} alt="" />;
      case "RightArrowIcon":
        return <img src={RightArrowIcon} alt="" />;
      case "PendingApprovalIcon":
        return <img src={PendingApprovalIcon} alt="" />;
      case "upload":
        return <img src={upload} alt="" className="FileIcon-cross mx-auto" />;
      case "NewAttachmentIcon":
        return (
          <img src={NewAttachmentIcon} alt="" className="attachment-img-new" />
        );
      case "AttachementCloseIcon":
        return (
          <img
            src={AttachementCloseIcon}
            alt=""
            className="FileIcon-cross mx-auto"
          />
        );
      case "RequestIcon":
        return <img src={RequestIcon} alt="" className="properties-img" />;
      case "BackArrowIcon":
        return <img src={BackArrowIcon} alt="" className="button-arrow-img" />;
      case "NextArrowIcon":
        return <img src={NextArrowIcon} alt="" className="button-arrow-img" />;
      case "RequestedByIcon":
        return <img src={RequestedByIcon} alt="" className="properties-img" />;
      case "EmployeeCodeIcon":
        return <img src={EmployeeCodeIcon} alt="" className="properties-img" />;
      case "WarningIcon":
        return <img src={WarningIcon} alt="" />;
      case "addIcon":
        return <img src={addIcon} alt="" />;
      case "Filter":
        return <img src={Filter} alt="" />;
      case "dateIconNew":
        return <img src={dateIconNew} alt="" className="properties-img-2" />;
      case "searchIcon":
        return <img src={searchIcon} alt="" className="properties-img-search" />;
      case "clearIcon":
        return <img src={clearIcon} alt="" className="properties-img-2" />;
      case "upArrow":
        return <img src={upArrow} alt="" />;
      case "downArrow":
        return <img src={downArrow} alt="" />;
      case "myteamactive":
        return <img src={myteamactive} alt="" />;
      case "CrossIcon":
        return (
          <img
            src={CrossIcon}
            alt=""
            className="cursor-pointer app-image-hover"
          />
        );
      case "ButtonSubmitIcon":
        return <img src={ButtonSubmitIcon} alt="" />;
      case "ButtonSubmitApprovalIcon":
        return (
          <img src={ButtonSubmitApprovalIcon} alt="" className="button-img" />
        );
      case "ButtonRejectApprovalIcon":
        return (
          <img src={ButtonRejectApprovalIcon} alt="" className="button-img" />
        );
      case "ButtonRejectIcon":
        return <img src={ButtonRejectIcon} alt="" />;
      case "vendoraddIcon":
        return <img src={vendoraddIcon} alt="" />;
      case "courseQuestionaireLogo":
        return <img src={courseQuestionaireLogo} alt="" />;
      case "courseDuration":
        return <img src={courseDuration} alt="" />;
      case "certificateCourseCatalogue":
        return <img src={certificateCourseCatalogue} alt="" />
      case "successTick":
        return <img src={successTick} alt="" />
      case "CourseQuestionIcon":
        return <img src={CourseQuestionIcon} alt="" />;
      case "textCourse":
        return <img src={textCourse} alt="" />
      case "url":
        return <img src={url} alt="" />
      case "urlWhite":
        return <img src={urlWhite} alt="" />
      case "textCourseRed":
        return <img src={textCourseRed} alt="" />
      case "exportIcon":
        return <img src={exportIcon} alt="" />

      case "smallCrossIcon":
        return <img src={smallCrossIcon} alt="" />;
      case "Vendorslogo":
        return <img src={Vendorslogo} alt="" />;
      case "VendorCodeIcon":
        return <img src={VendorCodeIcon} alt="" />;
      case "VendorNameIcon":
        return <img src={VendorNameIcon} alt="" />;
      case "ContactPersonIcon":
        return <img src={ContactPersonIcon} alt="" />;
      case "ContactNumberIcon":
        return <img src={ContactNumberIcon} alt="" />;
      case "supervisorIcon":
        return <img src={SupervisorIcon} alt="" />;
      case "statusIcon":
        return <img src={statusIcon} alt="" />;
      case "AddressIcon":
        return <img src={AddressIcon} alt="" />;
      case "CommentIcon":
        return <img src={CommentIcon} alt="" className="properties-img" />;
      case "VendorSubmit":
        return <img src={VendorSubmit} alt="" className="button-img" />;
      case "VendorEmail":
        return <img src={VendorEmail} alt="" />;
      case "Coursecatalogueiconactive":
        return <img src={Coursecatalogueiconactive} alt="" />;
      case "CourseCodeIcon":
        return <img src={CourseCodeIcon} alt="" className="properties-img" />;
      case "CourseTitleIcon":
        return <img src={CourseTitleIcon} alt="" className="properties-img" />;
      case "courseQuestionaireIcon":
        return <img src={courseQuestionaireIcon} alt="" />;
      case "courseCategoryIcon":
        return (
          <img src={courseCategoryIcon} alt="" className="properties-img-2" />
        );
      case "courseProviderIcon":
        return <img src={courseProviderIcon} alt="" />;
      case "courseDescIcon":
        return <img src={courseDescIcon} alt="" />;
      case "skillIcon":
        return <img src={skillIcon} alt="" />;
      case "courseCategoryMaxIcon":
        return <img src={courseCategoryMaxIcon} alt="" />;
      case "EditIcon":
        return <img src={EditIcon} alt="" />;
      case "RemoveIcon":
        return <img src={RemoveIcon} alt="" />;
      case "RemoveIcon1":
        return <img src={RemoveIcon} alt="" style={{marginTop:'4px'}}/>;
      case "SubCategoryIcon":
        return <img src={SubCategoryIcon} alt="" />;
      case "LeftArrowIcon":
        return <img src={LeftArrowIcon} alt="" />;
      case "RightArrowIcon":
        return <img src={RightArrowIcon} alt="" />;
      case "skillMaxIcon":
        return <img src={skillMaxIcon} alt="" />;
      case "jobMaxIcon":
        return <img src={jobMaxIcon} alt="" />;
      case "jobactiveicon":
        return <img src={jobactiveicon} alt="" />;
      case "jobicon":
        return <img src={jobicon} alt="" />;
      case "skillJobIcon":
        return <img src={skillJobIcon} alt="" />;
      case "skillJobActiveIcon":
        return <img src={skillJobActiveIcon} alt="" />;
      case "skillJobMaxIcon":
        return <img src={skillJobMaxIcon} alt="" />;
      case "supportingMaxIcon":
        return <img src={supportingMaxIcon} alt="" />;
      case "supportingIcon":
        return <img src={supportingIcon} alt="" />;
      case "supportingActiveIcon":
        return <img src={supportingActiveIcon} alt="" />;
      case "employeecode":
        return <img src={employeecode} alt="" />;
      case "coursetitle":
        return <img src={coursetitle} alt="" />;
      case "requestedby":
        return <img src={requestedby} alt="" />;
      case "skilleval":
        return <img src={skilleval} alt="" />;
      case "TrainingIcon":
        return <img src={TrainingIcon} alt="" />;
      case "trainingbondicon":
        return <img src={trainingbondicon} alt="" />;
      case "Skillmatrixicon":
        return <img src={Skillmatrixicon} alt="" />;
      case "staricon":
        return <img src={staricon} alt="" />;
      case "skilloverviewactive":
        return <img src={skilloverviewactive} alt="" />;
      case "Pendingheading":
        return <img src={Pendingheading} alt="" />;
      case "cancelrequest":
        return <img src={cancelrequest} alt="" />;
      case "FailedIcon":
        return <img src={FailedIcon} alt="" />;
      case "requesteddate":
        return <img src={requesteddate} alt="" />;
      case "submiticon":
        return <img src={submiticon} alt="" className="properties-img1" />;
      case "employeename":
        return <img src={employeename} alt="" />;
      case "crossicon":
        return <img src={crossicon} alt="" />;
      case "crossiconupload":
        return <img src={crossiconupload} alt="" className="mx-auto FileIcon-cross-new" />;
      case "historylog":
        return <img src={historylog} alt="" />;
      case "preskillevaluation":
        return <img src={preskillevaluation} alt="" />;
      case "certificatecoursetitle":
        return <img src={certificatecoursetitle} alt="" />;
      case "employeeid":
        return <img src={employeeid} alt="" />;
      case "currentstatus":
        return <img src={currentstatus} alt="" className="properties-img" />;
      case "requestId":
        return <img src={requestId} alt="" className="properties-img" />;
      case "upcomingTraining":
        return <img src={upcomingTraining} alt="" />;
      case "hoursIcon":
        return <img src={hoursIcon} alt="" />;
      case "AttachIcon":
        return <img src={AttachIcon} alt="" width={8} />;
      case "costTrainingIcon":
        return <img src={costTrainingIcon} alt="" />;
      case "backButtonIcon":
        return <img src={backButtonIcon} alt="" />;
      case "myjob":
        return <img src={myjob} alt="" />;
      case "pendinghome":
        return <img src={pendinghome} alt="" className="home-img-style" />;
      case "traningRecordsHome":
        return <img src={traningRecordsHome} alt="" className="home-img-style" />;
      case "pendingTraining":
        return <img src={pendingTraining} alt="" className="home-img-style" />;
      case "homeTraining":
        return <img src={homeTraining} alt="" />;
      case "mytraininghome":
        return <img src={mytraininghome} alt="" />;
      case "directreports":
        return <img src={directreports} alt="" />;
      case "upcomingtraining":
        return <img src={upcomingtraining} alt="" />;
      case "forwardicon":
        return <img src={forwardicon} alt="" />;
      case "developmentplan":
        return <img src={developmentplan} alt="" />;
      case "traininghours":
        return <img src={traininghours} alt="" />;
      case "description":
        return <img src={description} alt="" />;
      case "PTEMaxIcon":
        return <img src={PTEMaxIcon} alt="" />;
      case "pteIcon":
        return <img src={pteIcon} alt="" />;
      case "jobIcon":
        return <img src={jobIcon} alt="" className="mt-minus2px" />;
      case "skillKonwIcon":
        return <img src={skillKonwIcon} alt="" className="mt-minus2px" />;
      case "levelActive":
        return <img src={levelActive} alt="" />;
      case "levelIcon":
        return <img src={levelIcon} alt="" />;
      case "proficiencyIcon":
        return <img src={proficiencyIcon} alt="" />;
      case "proficiencyActiveIcon":
        return <img src={proficiencyActiveIcon} alt="" />;
      case "proficiencyExpected":
        return <img src={proficiencyExpected} alt="" />;
      case "back":
        return <img src={back} alt="" />;
      case "louactiveicon":
        return <img src={louactiveicon} alt="" />;
      case "louicon":
        return <img src={louicon} alt="" />;
      case "SkillKnowledgeIcon":
        return <img src={SkillKnowledgeIcon} alt="" />;
      case "Skill_Job_Icon":
        return <img src={Skill_Job_Icon} alt="" />;
      case "pteActive":
        return <img src={pteActive} alt="" />;
      case "cqActiveIcon":
        return <img src={cqActiveIcon} alt="" />;
      case "edit":
        return <img src={edit} alt="" />;
      case "addCourse":
        return <img src={addCourse} alt="" />;
      case "textCourse":
        return <img src={textCourse} alt="" />
      case "url":
        return <img src={url} alt="" />
      case "urlWhite":
        return <img src={urlWhite} alt="" />
      case "textCourseRed":
        return <img src={textCourseRed} alt="" />
      case "courseDuration":
        return <img src={courseDuration} alt="" />;
      case "certificateCourseCatalogue":
        return <img src={certificateCourseCatalogue} alt="" />
      case "successTick":
        return <img src={successTick} alt="" />
      case "docAttach":
        return <img src={docAttach} alt="" />;
      case "teamtrainingActive":
        return <img src={teamtrainingActive} alt="" />;
      case "skillActiveIcon":
        return <img src={skillActiveIcon} alt="" />;
      case "notifyActive":
        return <img src={notifyActive} alt="" />;
      case "pendingTraning":
        return <img src={directTraning} alt="" className="home-img-style" />;
      case "courseMasterActive":
        return <img src={courseMasterActive} alt="" />;
      case "courseMaster":
        return <img src={courseMaster} alt="" />;
      case "requestStatusIcon":
        return <img src={requestStatusIcon} alt="" />;
      case "requestStatusActiveIcon":
        return <img src={requestStatusActiveIcon} alt="" />;
      case "MyrequestStatusIcon":
        return <img src={MyrequestStatusIcon} alt="" />;
      case "trainingRecords":
        return <img src={trainingRecords} alt="" />;
      case "searchIcon1":
        return <img src={searchIcon1} alt="" />;
      case "calenderDate":
        return <img src={calenderDate} alt="" />;
      case "searchableIcon":
        return <img src={searchableIcon} alt="" />
      case "clearIcon1":
        return <img src={clearIcon1} alt="" />
      case "filterIcon":
        return <img src={filterIcon} alt="" />
      case "filterIconFill":
        return <img src={filterIconFill} alt="" />
      case "Filter1":
        return <img src={Filter1} alt="" />;
      case "backicon":
        return <img src={backicon} alt="" className="button-img" />;
      case "prevBackIcon":
        return <img src={prevBackIcon} alt="" />;
      case "Companyhead":
        return <img src={Companyhead} alt="" />
      case "Companyside":
        return <img src={Companyside} alt="" />
      case "Company_side_inActive":
        return <img src={Company_side_inActive} alt="" />
      case "PendingTaskHome":
        return <img src={PendingTaskHome} alt="" />
      case "MyselfIcon":
        return <img src={mySelfIcon} alt="" />
      case "mySelfIconActive":
        return <img src={mySelfIconActive} alt="" />

      default:
        return <img src={blankFile} alt="" />;

    }
  } else {
    // return <img src={blankFile} alt="" />;
  }
};

export default CommonIcon;
